import React, { Component } from "react";
import { Card, Form, Table } from "antd";
import util from "@util/index";
import { connect } from "react-redux";
import { getWorkOrgList } from "@store/modules/work_org_list";
import { BackBtn } from "@comm/BackBtn";
import { queryWageDetailPersonal } from "@api";

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
    };
  }

  componentDidMount() {
    this.props.dispatch(getWorkOrgList());
    this.getWageDetailInfo();
  }

  getWageDetailInfo = () => {
    queryWageDetailPersonal({ uuid: this.props.params.uuid }).then(res => {
      if (res.statusCode === 200) {
        const { workOrg } = this.props;
        const dataSource = [res.data];
        workOrg.map(item => {
          if (item.uuid === res.data.workorgname) {
            dataSource[0].workorgname = item.name;
          }
          return item;
        });
        this.setState({
          dataSource: [res.data],
        });
      }
    });
  };

  columns = () => {
    return [
      {
        title: "公司",
        dataIndex: "compname",
        width: 50,
      },
      {
        title: "部门",
        dataIndex: "workorgname",
        width: 50,
      },
      {
        title: "月份",
        dataIndex: "month",
        width: 80,
        render: (text, record) => <span>{`${record.year}-${record.month}`}</span>,
      },
      {
        title: "姓名",
        dataIndex: "person",
        width: 50,
      },
      {
        title: "应发项目",
        children: [
          {
            title: "基本工资",
            dataIndex: "base",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "岗位津贴",
            dataIndex: "performance",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "小计",
            dataIndex: "subtotal",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "全勤奖",
            dataIndex: "fullAttendance",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "绩效提成",
            dataIndex: "commission",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "补贴",
            dataIndex: "commissio",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "福利品",
            dataIndex: "welfare",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "合计",
            dataIndex: "wageSum",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
        ],
      },
      {
        title: "应扣项目",
        children: [
          {
            title: "缺勤",
            dataIndex: "absence",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "迟到扣款",
            dataIndex: "late",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "其他",
            dataIndex: "other",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "应发合计",
            dataIndex: "paid",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "社保",
            children: [
              {
                title: "个人",
                children: [
                  {
                    title: "养老保险",
                    dataIndex: "pensionInsurance",
                    width: 50,
                    render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
                  },
                  {
                    title: "医疗保险",
                    dataIndex: "medicalInsurance",
                    width: 50,
                    render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
                  },
                  {
                    title: "失业保险",
                    dataIndex: "unemploymentInsurance",
                    width: 50,
                    render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
                  },
                  {
                    title: "合计",
                    dataIndex: "insuranceSum",
                    width: 50,
                    render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
                  },
                ],
              },
              {
                title: "公司",
                dataIndex: "insuranceCompSum",
                width: 50,
              },
            ],
          },

          {
            title: "公积金",
            children: [
              {
                title: "个人部分",
                dataIndex: "providentFund",
                width: 50,
                render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
              },
              {
                title: "公司部分",
                dataIndex: "providentFundComp",
                width: 50,
                render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
              },
            ],
          },
          {
            title: "合计",
            dataIndex: "buckle",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
        ],
      },
      {
        title: "税前合计",
        dataIndex: "incomeBeforeTax",
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
      {
        title: "专项附加扣除",
        children: [
          {
            title: "子女教育",
            dataIndex: "childEductaion",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "继续教育",
            dataIndex: "continuingEducation",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "住房贷款利息",
            dataIndex: "homeLoanInterest",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "住房租金",
            dataIndex: "housingRent",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "赡养父母",
            dataIndex: "dependentParents",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "婴孩照护",
            dataIndex: "babyCare",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
          {
            title: "合计",
            dataIndex: "deductionTotal",
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
          },
        ],
      },
      {
        title: "本期应预扣预缴税额",
        dataIndex: "tax",
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
      {
        title: "税后合计",
        dataIndex: "incomeAfterTax",
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
      {
        title: "现金发放",
        dataIndex: "cashPayment",
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
      {
        title: "福利品发放",
        dataIndex: "welfarePayment",
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
      {
        title: "银行发放",
        dataIndex: "bankPayment",
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
    ];
  };

  render() {
    const { dataSource } = this.state;

    return (
      <div>
        <div style={{ marginBottom: "16px" }}>
          <BackBtn />
        </div>
        <Card>
          <Table
            size="small"
            bordered
            columns={this.columns()}
            dataSource={dataSource}
            pagination={false}
            rowKey="uuid"
            onChange={this.handleTableChange}
            scroll={{ x: 1630 }}
          />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  workOrg: state.work_org_list,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/home/wage/PageDetail.js